/**
 * @todo add support for reCaptcha v3
 * https://developers.google.com/recaptcha/docs/v3
 */
(function($) {
  'use strict';

  const forms = {
    dom: function() {
      this.$infieldLabels = $('[data-infield-label]');
      this.$datePicker    = $('[data-js-hook="pickadate"]');
      this.$checkbox      = $('input[data-checkbox][type="checkbox"]');
      this.$clearInput    = $('[data-input-clear]');

      this.file = {
        $toggle : $('[data-toggle="file"]'),
        $preview : $('[data-file="preview"]')
      };

      this.forms = {
        contact : $('#contact-form'),
        apply : $('#apply-form')
      };
    },

    settings: {
      activeFile: null
    },

    checkbox: function() {
      const $checkboxes = $('input[data-checkbox][type="checkbox"]');

      if ($checkboxes.length) {
        $checkboxes.each(function(){
          let $fakeCheckbox = $('[data-checkbox="' + $(this).data('checkbox') + '"]:not(input)');

          $(this).on('change', function(){
            if ($(this).prop('checked')) {
              $fakeCheckbox.addClass('form__checkbox-fake--checked');
            } else {
              $fakeCheckbox.removeClass('form__checkbox-fake--checked');
            }
          });
        });
      }
    },

    clearInputs: function() {
      this.$clearInput.click(function(event) {
        event.preventDefault();
        let input = $(this).data('input-clear');
        $('#' + input).val('').trigger('keyup').blur();
      });
    },

    datePicker: function() {
      if (this.$datePicker.length) {
        this.$datePicker.each(function() {
          let $this = $(this);
          let $label = $('label[for="' + $this.attr('id') + '"]');
          $this.on('mousedown',function(e){
            e.preventDefault();
          }).pickadate({
            format: 'mmm d, yyyy',
            disable: [
              { from: [0,0,0], to: new Date((new Date()).valueOf()-1000*60*60*24) }
            ],
            onSet: function(context) {
              if (typeof context.select != 'undefined') {
                $label.addClass('active');
              }
              else {
                $label.removeClass('active');
              }
            },
            onRender: function() {
              forms.$datePicker.removeAttr('aria-expanded');
              $($(this)[0].$root[0]).find('[aria-activedescendant]').removeAttr('aria-activedescendant');
            },
            onOpen: function() {
              $label.addClass('focus');
            },
            onClose: function() {
              this.$holder.blur();
              $label.removeClass('focus');
            }
          });
        });
      }
    },

    fileTrigger: function() {
      this.file.$toggle.click(function(event) {
        event.preventDefault();
        let $target = $($(this).data('target'));
        if ($target.length) {
          $target.trigger('click');
          forms.settings.activeFile = $target;
          forms.filePreview(true);
        }
      });
    },

    filePreview: function($bAfterTrigger) {
      if ($bAfterTrigger) {
        forms.settings.activeFile.change(function() {
          let id = forms.settings.activeFile.attr('id');
          let filename = $(this).val().split(/(\\|\/)/g).pop();
          forms.file.$preview.filter('[data-target="#' + id + '"]').html(filename).slideDown(100);
        });
      }
      else {
        $('input[type="file"]').each(function(index, element) {
          let $this = $(element);
          if ($this.val()) {
            let id = $this.attr('id');
            let filename = $this.val().split(/(\\|\/)/g).pop();
            forms.file.$preview.filter('[data-target="#' + id + '"]').html(filename).slideDown(100);
          }
        });
      }
    },

    infieldLabels: function() {
      this.$infieldLabels.each(function() {
        let self = $(this);
        let target = $(this).attr('for');
        let input = $('#'+target);
        if (input.val()) {
          self.addClass('active');
        }
        input.on('focus', function(){
          if (!$(this).val()) {
            self.addClass('focus');
          }
        });
        input.on('keyup input', function() {
          if ($(this).val()) {
            self.removeClass('focus');
            self.addClass('active');
          }
          else {
            self.removeClass('active');
            self.addClass('focus');
          }
        });
        input.on('blur', function() {
          if (!$(this).val()) {
            self.removeClass('focus');
          }
        });
      });
    },

    formModalTimeout: function(form) {
      // close modal
      let $modal = $(form).closest('.modal');
      if ($modal.length) {
        let $timeout = $modal.find('[data-js-hook="success-timeout"]');
        let $number = $timeout.find('[data-success-timeout-number]');
        if ($timeout.length && $number.length) {
          $timeout.show();

          let start = 1;
          let end = jcms.form_settings.timeout;
          let display = end;

          let countdown = setInterval(function() {
            if (start <= end) {
              --display;
              $number.text(display);
              ++start;
            }
            else {
              clearInterval(countdown);
              $timeout.hide();
            }
          }, 1000);

          setTimeout(function() {
            $modal.find('[data-dismiss="modal"]').first().trigger('click');
          }, jcms.form_settings.timeout * 1000);
        }
      }
    },

    formValidation: function() {
      // -- Validate the form
      let requiredFields = {
        contact: 'FirstName, LastName, Email{email}, Message',
        apply: 'First Name, Last Name, Email{email}, Resume{file}'
      };

      if (typeof jcms.contactPhoneRequired != 'undefined' && jcms.contactPhoneRequired) {
        requiredFields.contact += ',Phone';
      }

      if (typeof jcms.contactZipRequired != 'undefined' && jcms.contactZipRequired) {
        requiredFields.contact += ',Zip';
      }

      $.each(this.forms, function(key, form) {
        if (!$(this).length) {
          return;
        }
        let $form = $(this);
        let id = form.attr('id');
        let required = [];
        $(this).find('[data-field-required]').each(function() {
          let $input = $(this).find('input,textarea,select');
          if (!$input.length) {
            return;
          }

          let type = '';
          if ($input[0].tagName.toLowerCase() === 'input') {
            if ($input.attr('type').toLowerCase() !== 'text' && $input.attr('type').toLowerCase() !== 'checkbox') {
              type = '{' + $input.attr('type').toLowerCase() + '}';
            }
          }
          required.push($input.attr('name') + type);
        });

        required = required.length ? required.join(',') : requiredFields[key];

        form.formulate({
          id: id,
          require: required,
          errorClass: 'error',
          errorParent: true,
          showOnSubmit: '[data-js-hook="' + id + '-confirm"]',
          inlineMsg: true,
          inlineMsgClass: 'form__inline-error',
          fireOnSubmit: function(data, form) {
            $('.form__message', $(form)).remove();
          },
          fireOnSuccess: function(data, form, settings) {
            if (typeof JonahTracking != 'undefined') {
              JonahTracking.event.formSubmit($(form).attr('id'));
            }
            if (typeof cmg_google_conversion != 'undefined') {
              cmg_google_conversion($('#' + id.replace('-','_') + '_conversion').val(), $('#' + id.replace('-','_') + '_conversion_id').val(), $('#' + id.replace('-','_') + '_conversion_html').val());
            }
            jutil.replaceFormConfirmMessageVariables($form, $('[data-js-hook="' + id + '-confirm"]'));
            forms.formModalTimeout(form);
          },
          fireOnError: function(data, form) {
            if (data !== false) {
              let response;
              try {
                response = JSON.parse(data);
                response = response.message;
              } catch(e) {
                response = data;
              }
              let $message = '<p class="form__message background-error">' + response + '</p>';
              $(form).prepend($message);
            }
            if ($('.error :input', $(form)).length) {
              $('.error :input', $(form))[0].focus();
            }
          }
        });
      });
    },

    ready: function() {
      this.dom();
      this.checkbox();
      this.clearInputs();
      this.datePicker();
      this.fileTrigger();
      this.filePreview();
      this.infieldLabels();
      this.formValidation();
    }
  };

  $(function() { forms.ready(); });

})(jQuery);
